import { Box } from "@mui/material";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";

export const SyncBadge = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        width: 8,
        height: 8,
        backgroundColor: "#ff4444",
        color: "white",
        borderRadius: "50%",
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SyncProblemIcon sx={{ width: "100%", height: "100%" }} />
    </Box>
  );
};
